import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Integrations as TracingIntegrations } from '@sentry/tracing'

import * as amplitude from '@amplitude/analytics-browser'

import VueClipboard from 'vue-clipboard2'

import App from '@/App.vue'
import vuetify from '@/lib/vuetify'
import router from '@/lib/router'
import store from '@/lib/store'
import client from '@/lib/client'
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false
const prod = process.env.NODE_ENV === 'production'
var sentry_env = 'production'
if (!prod) {
  sentry_env = 'dev'
}

// Report to sentry if production. Attach props but also log to console.
Sentry.init({
  dsn: 'https://4bfc38c420bd49639445240ae6b97de8@sentry.io/1727916',
  environment: sentry_env,
  integrations: [
    new TracingIntegrations.BrowserTracing({
      tracingOrigins: ['localhost', 'api-tournament.numer.ai', /^\//],
      beforeNavigate: context => {
        // TODO: there is surely a better way to do this but I don't understand
        //       vue routes to know how yet
        let routes = [
          '/leaderboard',
          '/tournament',
          '/login',
          '/signup',
          '/stake',
          '/compute',
          '/reset',
          '/account',
          '/wallet',
          '/terms',
          '/notebook',
          '/models',
          '/submissions',
          '/scores',
          '/staking',
        ]
        if (routes.includes(location.pathname)) {
          return {
            ...context,
            name: location.pathname,
          }
        }
        return {
          ...context,
          name: location.pathname
            .replace(/^\/([a-z0-9_]{1,20})\/*$/g, '/<model>')
            .replace(
              /^\/([a-z0-9_]{1,20})\/submissions$/g,
              '/<model>/submissions',
            )
            .replace(
              /^\/([a-z0-9_]{1,20})\/submissions\/\d+$/g,
              '/<model>/submissions/<round>',
            )
            .replace(/^\/verify-ip\/[A-Z0-9]{52}====$/g, '/verify-ip/<token>')
            .replace(/^\/round\/\d+$/g, '/round/<number>')
            .replace(/^\/([a-z0-9_]{1,20})\/settings$/g, '/<model>/settings'),
        }
      },
    }),
  ],
  tracesSampleRate: 0.2,
  tracingOptions: {
    trackComponents: true,
  },
})

let amplitudeApiKey
if (process.env.NODE_ENV === 'production') {
  amplitudeApiKey = '281740aa772327173c8b6cfeda720435'
} else {
  amplitudeApiKey = '9c03ab9f1703909f9a20b0485313a29b'
}
const sensitiveUrls = [
  'reset-password/u',
  'confirm',
  'verify',
  'reset-email',
  'verify-ip',
  'unsubscribe',
]
amplitude.init(amplitudeApiKey, {
  autocapture: {
    attribution: {
      excludeReferrers: sensitiveUrls.map(url => {
        return new RegExp(`^${url}`)
      }),
    },
    pageViews: {
      trackOn: () => {
        return !sensitiveUrls.some(url =>
          window.location.pathname.includes(url),
        )
      },
    },
  },
})

Vue.use(VueClipboard)

// load auth token from local storage
store.dispatch('loadAuthInfo')

// load multi-model ack
store.dispatch('loadMultiModelAck')

// load account and selected model state
store.dispatch('loadSelectedModelId')

// poll for NMR/ETH prices
store.dispatch('pollForPrices')

store.dispatch('loadDarkMode')

// logout and refresh page if token is invalid/expired
client.setOn401Callback(() => {
  store.dispatch('clearAuthInfo')
  // set this flag to avoid infinite loops in signal IframeAuth
  localStorage.setItem('invalidLocalAuthInfo', true)
  router.go()
  store.dispatch('showSnackBar', {
    msg: 'Login expired - please login again!',
    time: 0,
  })
})

client.setGraphQLErrorCallback(() => {
  store.dispatch('showSnackBar', {
    msg: 'GraphQL error - please refresh the page!',
    time: 0,
  })
})

// this needs to be the last thing we do in this file
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.use(VTooltip)

Vue.config.errorHandler = err => {
  console.error('Exception: ', err)
}
